import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const EventsRaw = React.lazy(() => import(/* webpackChunkName: "EventsPage" */ 'containers/Events/Events'));
export const Events = () => (React.createElement(Page, { title: "Actions", description: "Push Actions" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(EventsRaw, null)))));
